<script setup>
import {defineProps} from "vue"

defineProps({
  serviceTitle:{type:String, default:'Appartement Meublé'},
  serviceDesc:{type:String, default:'Location et reservation d\'appartement'},
  serviceLink:{type:String, default:'/apartments'},
  serviceImg:{type:String, default:'src/assets/images/logos/logo_1.jpeg'},
  serviceActionTitle:{type:String, default:'details'},
})
</script>

<template>
  <div><!-- Services Item #1 -->
    <div class="uk-card uk-card-default uk-box-shadow-hover-xlarge impx-service-card uk-padding-bottom">
      <div class="uk-card-media-top">
        <img :src="serviceImg" alt="service img">
      </div>
      <div class="uk-card-body uk-card-small uk-text-center">
        <div class="uk-card-badge uk-label uk-label-danger bg-color-aqua">{{serviceTitle}}</div>
        <p>{{serviceDesc}}</p>
        <router-link :to="serviceLink" class="uk-button uk-button-default uk-button-small impx-button gray
        impx-button-outline outline-red button-wide impx-button-rounded small-border" style="border: 2px solid rgba(128,136,156,1.0) !important;
    color: rgba(214,47,47,1.0);border-radius: 20px;">{{serviceActionTitle}} &raquo;</router-link>
      </div>
    </div>
  </div><!-- Services Item #1 End -->
</template>

<style scoped>
</style>